import React from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import {Link, Text} from '@edume/magnificent';

import styles from './styles.module.scss';

function StoreInfoBar({selectedStoreId, stores, resetStore}) {
  const selectedStoreName = stores.find(
    (store) => store.id === selectedStoreId
  )?.name;

  return (
    <div styleName='store-info-bar'>
      <div styleName='store-info-bar-inner'>
        <div styleName='store-info-bar-text'>
          <Text
            colour='textSecondary'
            inline='false'
            lineHeight='tight'
            size='l'
            textTransform='none'
            weight='medium'
          >
            Current selection:
          </Text>
          <Text
            colour='textPrimary'
            inline='false'
            lineHeight='tight'
            size='l'
            textTransform='none'
            weight='medium'
          >
            {selectedStoreName}
          </Text>
        </div>
        {selectedStoreId && (
          <Link
            onClick={resetStore}
            icon=''
            linkColour='primary'
            linkSize='snail'
            text='Reset'
          />
        )}
      </div>
    </div>
  );
}

StoreInfoBar.propTypes = {
  selectedStoreId: PropTypes.func,
  stores: PropTypes.array,
  resetStore: PropTypes.func,
};

export default CSSModules(StoreInfoBar, styles, {allowMultiple: true});
